
import { useState } from 'react';

export default function AICapabilities() {
  const [activeTab, setActiveTab] = useState(0);

  const capabilities = [
    {
      title: 'Data Type Detection',
      description: 'Our AI and algorithms make suggestions inferences and simplify structures. We make recommendations in data standardization.',
      image: '/assets/images/ai-data-type.gif'
    },
    {
      title: 'Accurate Documents Merging',
      description: 'Automatically detect columns that can help you to join two data sets.',
      image: '/assets/images/ai-merge.gif'
    },
    {
      title: 'Text Understanding',
      description: 'Our integrated Natural Language Processing algorithms detect similar sounding or spelled words and phrases. We suggest which clusters could be standardized to most commonly used values.',
      image: '/assets/images/ai-text-nlp.gif'
    }
  ];

  return (
    <section className="bg-white py-20">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            AI Empowered Data Preparation for 20x Results using GPUs
          </h2>
          <p className="text-lg text-gray-600">
            Learn how Artificial Intelligence helps you to clean your data faster
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-2/3 order-2 lg:order-1">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
              <img 
                src={capabilities[activeTab].image}
                alt={capabilities[activeTab].title}
                className="w-full h-auto"
              />
            </div>
          </div>

          <div className="lg:w-1/3 order-1 lg:order-2 space-y-4">
            {capabilities.map((capability, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(index)}
                className={`w-full text-left p-6 rounded-lg transition-all duration-300 cursor-pointer ${
                  activeTab === index
                    ? 'bg-[#FFD93D] shadow-md'
                    : 'bg-gray-50 hover:bg-gray-100'
                }`}
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {capability.title}
                </h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                  {capability.description}
                </p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
